import { trackEvent } from '@/components/Event/_lib/eventTrack';
import { Image } from '@/components/Image';
import { WebviewActionHideKeyboard } from '@/utils/action';
import { KeyboardEventHandler, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { PhotocardsContext } from '../Provider';

interface IProps {
  onClose: () => void;
}

export default function PocaSearchModal({ onClose }: IProps) {
  const { group, member } = useContext(PhotocardsContext);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const paramsSearchValue = searchParams.get('q') ?? '';
  const [searchValue, setSearchValue] = useState(paramsSearchValue);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleResetSearch = () => {
    setSearchValue('');
    searchParams.delete('q');
    navigate(`${location.pathname}?${searchParams}`);
  };

  const handleSubmit = () => {
    searchParams.set('q', searchValue);
    navigate(`${location.pathname}?${searchParams}`);
    WebviewActionHideKeyboard();
    onClose();
  };

  const handleClickSearch: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === 'Enter') {
      WebviewActionHideKeyboard();
      handleSubmit();
      trackEvent('PLP_search_POCA', { keyword: searchValue, Member: member?.name_en, Group: group.name_en });
    }
  };

  useEffect(() => setSearchValue(paramsSearchValue), [paramsSearchValue]);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="fixed inset-0 flex w-full backdrop-blur-[1.5px] h-full bg-white/10 z-[100]" onClick={onClose}>
      <div className="w-full h-[52px] bg-white z-[100]" onClick={(e) => e.stopPropagation()}>
        <div className="w-[800px] flex justify-between items-center p-4 gap-2 h-[52px] rounded-[40px] bg-white border border-[#f5f5f5] absolute top-[190px] right-[340px]">
          {/* 왼쪽 아이콘 + 텍스트 */}
          <div className="flex gap-2 shrink-0">
            <Image src="/icons/search-gray.svg" alt="search-gray-svg" width={24} height={24} className="text-[#999999]" />
            <div className="bg-black text-[13px] h-[28px] font-medium text-white py-1 px-2 rounded-lg whitespace-nowrap">
              Searching in: {member?.name_en}
            </div>
          </div>

          <input
            ref={inputRef}
            className="flex-grow text-[16px] leading-6 font-medium outline-none"
            type="text"
            value={searchValue}
            placeholder={'Search photocards✨'}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleClickSearch}
          />

          {/* 오른쪽 버튼 */}
          {searchValue && (
            <button
              type="button"
              aria-label="Clear search"
              onClick={handleResetSearch}
              className="p-0 bg-transparent border-0 shrink-0"
            >
              <Image src="/icons/huge.svg" alt="close-svg" aria-hidden width={24} onClick={() => setSearchValue('')} />
            </button>
          )}
        </div>

        <div
          className="px-4 py-4 rounded-[40px] text-[#737373] text-[14px] font-medium bg-white absolute top-[190px] right-[250px]"
          onClick={onClose}
        >
          Cancel
        </div>
      </div>
    </div>
  );
}
